import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=1aa55704"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=1aa55704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports